var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Promotion'),_vm._v(" "),(_vm.mobileNavi !== true)?_c('Header'):_vm._e(),_vm._v(" "),_c('Navigation',{on:{"mobile-navi":_vm.setMobileNavi}}),_vm._v(" "),(_vm.mobileNavi !== true)?_c('Nuxt'):_vm._e(),_vm._v(" "),(_vm.mobileNavi !== true)?_c('Footer'):_vm._e(),_vm._v(" "),_c('CookieConsentBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }